module.exports = __webpack_public_path__ + "img/img0.f63379c5.jpg";